import React, {useEffect, useState} from "react";
import styled from "styled-components";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

export default function CustomDataGrid({rows, columns, rowHeight, showQuickFilter}){

  //  const [searchParam, setSearchParam] = useState([]);
 // const [pageState, setPageState] = useState({});
  const [loading, setLoading] = useState(true);
  // const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    if(rows.length > 0){
      setLoading(false);
     }    
    }, [rows, columns, rowHeight]);
  

   return (
    <Wrapper>
      <DataGrid     
          autoHeight
          rows={rows}
          columns={columns}
          slots={{toolbar: GridToolbar}}
          loading={loading}
          disableColumnSelector                                    
          disableVirtualization={false}
        //pageSizeOptions={[20, 50, 100]}
          rowHeight={rowHeight}      
          initialState={{
            pagination: {
              paginationModel: { pageSize: 50, page: 0 },
            },
          }}
          pagination
          slotProps={{
           toolbar: {
            showQuickFilter: showQuickFilter ? false : true ,
            quickFilterProps: { debounceMs: 600 },
                    },
         }}
      />
    </Wrapper>
   );
};


const Wrapper = styled.div`


` ;